import $http from '../connectionProxy'

export const getGender = () => {
  return $http.get(`/genders`)
}

export const getBloodType = () => {
  return $http.get(`/blood_types`)
}

export const getActivities = () => {
  return $http.get(`/activities`)
}

export const getBuildings = () => {
  return $http.get(`/buildings`)
}

export const getClassrooms = (buildingId) => {
  return $http.get(`/buildings/${buildingId}/classrooms`)
}
